import http from '../../http'

const tableauToken = ({ email }) => http.post(`utils/tableau-token`, { email })

const validateUnique = payload => http.post('utils/unique', payload)

const autoFill = payload => http.post('utils/autofill ', payload)

const smsValidation = payload => http.post('utils/sms-validation', payload)

const whatsappValidation = payload => http.post('utils/whatsapp-validation', payload)

export { validateUnique, smsValidation, autoFill, whatsappValidation }

const util = {
  validateUnique,
  smsValidation,
  tableauToken,
  whatsappValidation
}

export default util
